module.exports = __webpack_public_path__ + "static/396FC6_8_0-7678a7cfd1e596b373778f1ae4d5eed3.woff2";